import { Languages } from '@ratehub/base-ui';


/**
 * Intended to return just the CardFinder page URL segments for CardFinder routing, this may also be used to
 * return the tail end of a CardFinder path that includes /cardfinder by using an array as the second arg.
 * @param {string} language - accepts either a language or a locale
 * @param {string|string[]} cardFinderSegments - a recognized key from within CARDFINDER_URL_SEGMENT_SLUGS
 * @returns {string} the requested CardFinder URL page segment, or a concatenation if cardFinderSegments is an array
 */
function getCardFinderURLSegments(language, cardFinderSegments) {
    const urlLanguage = language?.slice(0, 2);

    if (![ Languages.ENGLISH, Languages.FRENCH ].includes(urlLanguage)) {
        throw new RangeError(`getCardFinderURLSegments: unrecognized language code “${urlLanguage}”`);
    }

    // always traverse an array, even if they passed in a string
    return [].concat(cardFinderSegments).map(slug => {
        if (!CARDFINDER_URL_SEGMENTS[slug]?.[urlLanguage]) {
            throw new RangeError(
                `getCardFinderURLSegments: unrecognized CardFinder segment slug “${slug}” • ${typeof slug}`
            );
        }

        return CARDFINDER_URL_SEGMENTS[slug][urlLanguage];
    }).join('');
}


// ideally, we might like cc-cardfinder be home to its page URLs, but we define them here in cc-common
// because cc-common needs access to them was well

// another goal of this structure was to never repeat a segment, like /cardfinder in multiple places
const CARDFINDER_URL_SEGMENTS = {
    CARDFINDER_SEGMENT: {
        en: '/cardfinder',
        fr: '/chercheur-des-cartes',
    },

    CARD_TYPE_SEGMENT: {
        en: '/card-type',
        fr: '/type-de-cartes-de-credit',
    },

    ELIGIBILITY_CHECKER_SEGMENT: {
        en: '/eligibility-checker',
        fr: '/controleur-d-eligibilite',
    },

    RESULTS_SEGMENT: {
        en: '/results',
        fr: '/resultats',
    },

    RESUME_SEGMENT: {
        en: '/resume',
        fr: '/resume',
    },

};

// you may use this map to ensure the slug argument to getCardFinderURLSegments() is without typos
//  CARDFINDER_URL_SEGMENT_SLUGS = {
//      'CARDFINDER_SEGMENT': 'CARDFINDER_SEGMENT',
//      'CARD_TYPE_SEGMENT': 'CARD_TYPE_SEGMENT',
//      ...
const CARDFINDER_URL_SEGMENT_SLUGS = Object.keys(CARDFINDER_URL_SEGMENTS).reduce((slugs, thisSlug) => ({
    ...slugs,
    [thisSlug]: thisSlug,
}), {});


export { CARDFINDER_URL_SEGMENT_SLUGS };
export default getCardFinderURLSegments;
